import GeoJSON  from 'geojson'

const GeoJSONWrapper = {
    wrapsensors: function (sensors) {
        var geojson = {};
        geojson['type'] = 'FeatureCollection';
        geojson['features'] = [];
        for (var s in sensors) {
            //avoid sensors with no location for map
            if(sensors[s].location && sensors[s].location.longitude !== 0 && sensors[s].location.latitude !== 0){
                var newFeature = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [sensors[s].location.longitude, sensors[s].location.latitude],
                    },
                    "properties": {
                        "id": sensors[s].id,
                        "name": sensors[s].name,
                        "enabled" : sensors[s].enabled,
                        "description" : sensors[s].description,
                        "providerid" : sensors[s].provider.id,
                        "statuscolor" : sensors[s].statuscolor,
                    }
                }
                geojson['features'].push(newFeature);
            }
        }
        return geojson;
    },
    wrapfanspeedsensors: function (sensors) {
        var geojson = {};
        geojson['type'] = 'FeatureCollection';
        geojson['features'] = [];
        for (var s in sensors) {
            //avoid sensors with no location for map
            if(sensors[s].location && sensors[s].location.longitude !== 0 && sensors[s].location.latitude !== 0){
                var newFeature = {
                    "type": "Feature",
                    "geometry": {
                        "type": "Point",
                        "coordinates": [sensors[s].location.longitude, sensors[s].location.latitude],
                    },
                    "properties": {
                        "id": sensors[s].id,
                        "name": sensors[s].name,
                        "enabled" : sensors[s].enabled,
                        "description" : sensors[s].description,
                        "providerid" : sensors[s].provider.id,
                        "statuscolor" : sensors[s].statuscolor,
                        "statustext": sensors[s].statustext ? (sensors[s].statustext.length > 0  ? sensors[s].statustext[0].text : '' ) : ''
                    }
                }
                geojson['features'].push(newFeature);
            }
        }
        return geojson;
    },
    wrapmobilesensors24hobs: function (sensors, propertyname) {
        var geojson = {};
        geojson['type'] = 'FeatureCollection';
        geojson['features'] = [];
 
        for (var s in sensors) {
            for(var o in sensors[s][propertyname]){
                //avoid sensors with no location for map
                if(sensors[s][propertyname][o].longitude !== 0 && sensors[s][propertyname][o].latitude !== 0){
                    var newFeature = {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [sensors[s][propertyname][o].longitude, sensors[s][propertyname][o].latitude ],
                        },
                        "properties": {
                            "id": sensors[s].id,
                            "name": sensors[s].name,
                            "enabled" : sensors[s].enabled,
                            "description" : sensors[s].description,
                            "providerid" : sensors[s].provider.id,
                            "statuscolor" : sensors[s].statuscolor,
                            "component" : sensors[s][propertyname][o].component,
                            "value" : sensors[s][propertyname][o].value,
                            "unit" : sensors[s][propertyname][o].unit,
                            "timestamp_to_epoch": sensors[s][propertyname][o].timestamp_to_epoch
                        }
                    }
                    geojson['features'].push(newFeature);
                }
            }

        }
        return geojson;
    },
    
    wrapStaticSensorLastMeasurements: function (obs, sensors) {
        var geojson = {};
        geojson['type'] = 'FeatureCollection';
        geojson['features'] = [];
 
        for (var s in obs) {
            //avoid sensors with no aggregated data
            let hasObs = obs[s].AggObservations.length !== 0 ? true : false ;  
                if(hasObs){
                let staticSensor = sensors.find( sensor => sensor.id == obs[s].id);
                let newestdata = hasObs ? obs[s].AggObservations.reduce((p, c) => p.timestamp_to_epoch > c.timestamp_to_epoch ? p : c) : staticSensor.location;
                if(newestdata.longitude !== 0 && newestdata.latitude !== 0){
                    var newFeature = {
                        "type": "Feature",
                        "geometry": {
                            "type": "Point",
                            "coordinates": [newestdata.longitude, newestdata.latitude ],
                        },
                        "properties": {
                            "id": obs[s].id,
                            "name": obs[s].name,
                            "component" : obs[s].component,
                            "providerid" : staticSensor.provider.id,
                            "value" : hasObs ? newestdata.avg : -9999 ,
                            "unit" : hasObs ? newestdata.unit : '',
                            "timestamp_to_epoch": hasObs ? newestdata.timestamp_to_epoch : 0
                        }
                    }
                    geojson['features'].push(newFeature);
                }
            }
        }
        return geojson;
    }
  }

  
  export default GeoJSONWrapper;